module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAASCAYAAABit09LAAAAAXNSR0IArs4c6QAAAQZJREFUKBWtUjESgjAQJNABT+AD1hbWtMCM/sJGf6CdT7DxFzoDtNQU1H7AJwBdwN1AnMgIlTdzyWV37ya5i2VNLM/zHX0CW8IEiqLwm6Z5EvM8bxWGYa15Wwfc27a99H0f0Bmb3KdimqZrCEqQziiQQohNkiQVz6oiBCRvcC0ip7CRG4RZlh0BrMmaRowcMYEXBlJKPsA3RUZcO46zsruuuy6IqPdHjZH7j1CgLXdcertUDG162LADRJ8J/EioqbGjKHoh4/xDoCBySsMTm4p+ldNeQlTFcbzBLtVkGEC/h3PXprCRGyZDhjPFXdhTZYz1nAl8/R7XdU+owDu/GA8pM+vcx30DXyNvfNbys9cAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/static/images/home_sort.png
// module id = 837
// module chunks = 106